// extracted by mini-css-extract-plugin
export default {"fraudReportSearchForm":"fraud-report-search-form__fraud-report-search-form__Scgkx","buttonDiv":"fraud-report-search-form__button-div__YspvD"};